import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface LiveKeywordFilters {
  addTime: string[]
}

export interface LiveKeywordRecord {
  id: string | number
  keyword: string
  eventsId: string | number
  times: string
  totalNum: number
}

export interface LiveKeywordForm {
  keyword: string
  eventsId: string | number
  addTime: Date[]
}

export interface LiveKeywordEvent {
  rowId: string | number
  eventName: string
}

export async function fetchLiveKeywordPage(
  query: PageQuery<LiveKeywordFilters>,
  signal: AbortSignal
): Promise<PageResult<LiveKeywordRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/liveKeyword/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<LiveKeywordRecord>(payload)
}

export async function fetchLiveKeywordEventOptions() {
  const payload = await requestV2.get<unknown>({
    url: '/main/customerEvents/queryByCondition',
    params: { pageNo: 1, pageSize: 1000 }
  })
  return normalizePageResult<LiveKeywordEvent>(payload).records
}

export function createLiveKeyword(payload: LiveKeywordForm) {
  return requestV2.post<void>({ url: '/main/liveKeyword/add', data: payload })
}

export function deleteLiveKeyword(id: LiveKeywordRecord['id']) {
  return requestV2.delete<void>({ url: `/main/liveKeyword/${id}` })
}
